import { createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";
import { CountriesTypes } from "./countries-actions";

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
    fetchingCountry: null,
    fetchingCountries: null,
    fetchingIdentityDocuments: null,
    fetchingIdentityDocument: null,
    fetchingIdentityCount: null,
    fetchingZones: null,
    updating: null,
    updatingCountry: null,
    creating: null,
    disabling: null,
    countries: null,
    countryData: null,
    country: null,
    count: null,
    identityDocument: null,
    identityDocuments: null,
    zones: null,
    errorFetchingCountry: null,
    errorCountries: null,
    errorIdentityDocument: null,
    errorIdentityDocuments: null,
    errorUpdating: null,
    errorUpdatingCountry: null,
    errorCreating: null,
    errorDisabling: null,
    errorIdentityCount: null,
    errorFetchingZones: null
});

/* ------------- Reducers ------------- */

// request the data from an api
export const countryRequest = (state) => {
    return { ...state, fetchingCountry: true }
}

// request the data from an api
export const saveCountry = (state, action) => {
    const { country } = action;
    return { ...state, country }
}

// request the data from an api
export const idDocsCountRequest = (state) => {
    return { ...state, fetchingIdentityCount: true }
}

// request the data from an api
export const idDocRequest = (state) => {
    return { ...state, fetchingIdentityDocument: true }
}


// request the data from an api
export const countriesRequest = (state, action) => {
    const { countries } = action;
    return { ...state, countries, fetchingCountries: true };
};

// request the data from an api
export const idDocsRequest = (state) => {
    return { ...state, fetchingIdentityDocuments: true }
}

// request the data from an api
export const updateDocRequest = (state) => {
    return { ...state, updating: true }
}
// request the data from an api
export const createDocRequest = (state) => {
    return { ...state, creating: true }
}
// request the data from an api
export const disableIdDocRequest = (state) => {
    return { ...state, disabling: true };
};

// request the data from an api
export const updateCountryRequest = (state) => {
    return { ...state, updatingCountry: true }
}

// request the data from an api
export const zonesRequest = (state) => {
    return { ...state, fetchingZones: true }
}

// successful api lookup for id
export const countrySuccess = (state, action) => {
    const { country } = action;
    return { ...state, country, fetchingCountry: false, errorFetchingCountry: null }
}

// successful api lookup for id
export const idDocsCountSuccess = (state, action) => {
    const { count } = action;
    return { ...state, count, fetchingIdentityCount: false, errorIdentityCount: null }
};

// successful api lookup for id
export const idDocSuccess = (state, action) => {
    const { identityDocument } = action;
    return { ...state, identityDocument, fetchingIdentityDocument: false, errorIdentityDocument: null }
};

// successful api lookup for countries
export const countriesSuccess = (state, action) => {
    const { countries } = action;
    return { ...state, countries, fetchingCountries: false, errorCountries: null, }
};

// successful api lookup for updating
export const updateDocSuccess = (state, action) => {
    const { identityDocument } = action;
    return { ...state, identityDocument, updating: false, errorUpdating: null, }
};

// successful api lookup for creating
export const createDocSuccess = (state, action) => {
    const { identityDocument } = action;
    return { ...state, identityDocument, creating: false, errorCreating: null, }
};

// successful api lookup for ids
export const idDocsSuccess = (state, action) => {
    const { identityDocuments } = action;
    return { ...state, identityDocuments, fetchingIdentityDocuments: false, errorIdentityDocuments: null }
};
// successful api lookup for delete
export const disableIdDocSuccess = (state) => {
    return { ...state, disabling: false, errorDisabling: null };
};

// successful api lookup for updating country
export const updateCountrySuccess = (state, action) => {
    const { countryData } = action
    return { ...state, countryData, updatingCountry: false, errorUpdatingCountry: null }
}

// successful api lookup for getting zones
export const zonesSuccess = (state, action) => {
    const { zones } = action
    return { ...state, zones, fetchingZones: false, errorFetchingZones: null }
}

// Something went wrong fetching id
export const countryFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingCountry: false, errorFetchingCountry: error }
}

// Something went wrong fetching id
export const idDocsCountFailure = (state, action) => {
    const { error } = action;
    return { ...state, fetchingIdentityCount: false, errorIdentityCount: error }
};

// Something went wrong fetching id
export const idDocFailure = (state, action) => {
    const { error } = action;
    return { ...state, fetchingIdDocument: false, errorIdDocument: error }
};

// Something went wrong fetching countries
export const countriesFailure = (state, action) => {
    const { error } = action;
    return { ...state, fetchingCountries: false, errorCount: error }
};

// Something went wrong fetching id
export const idDocsFailure = (state, action) => {
    const { error } = action;
    return { ...state, fetchingIdentityDocuments: false, errorIdentityDocuments: error }
};

// Something went wrong creating
export const createDocFailure = (state, action) => {
    const { error } = action;
    return { ...state, creating: false, errorCreating: error }
};

// Something went wrong updating
export const updateDocFailure = (state, action) => {
    const { error } = action;
    return { ...state, updating: false, errorUpdating: error }
};
// Something went wrong updating
export const disableIdDocFailure = (state, action) => {
    const { error } = action;
    return { ...state, disabling: false, errorDisabling: error };
};

// Something went wrong updating a country
export const updateCountryFailure = (state, action) => {
    const { error } = action;
    return { ...state, updatingCountry: false, errorUpdatingCountry: error }
}

// Something went wrong fetching zones
export const zonesFailure = (state, action) => {
    const { error } = action;
    return { ...state, zones: false, errorFetchingZones: error }
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
    [CountriesTypes.COUNTRY_REQUEST]: countryRequest,
    [CountriesTypes.COUNTRIES_REQUEST]: countriesRequest,
    [CountriesTypes.IDENTITY_DOCUMENT_REQUEST]: idDocRequest,
    [CountriesTypes.IDENTITY_DOCUMENTS_COUNT_REQUEST]: idDocsCountRequest,
    [CountriesTypes.IDENTITY_DOCUMENTS_REQUEST]: idDocsRequest,
    [CountriesTypes.UPDATE_DOCUMENT_REQUEST]: updateDocRequest,
    [CountriesTypes.CREATE_DOCUMENT_REQUEST]: createDocRequest,
    [CountriesTypes.DISABLE_IDENTITY_DOCUMENT_REQUEST]: disableIdDocRequest,
    [CountriesTypes.UPDATE_COUNTRY_REQUEST]: updateCountryRequest,
    [CountriesTypes.ZONES_REQUEST]: zonesRequest,

    [CountriesTypes.COUNTRY_SUCCESS]: countrySuccess,
    [CountriesTypes.COUNTRIES_SUCCESS]: countriesSuccess,
    [CountriesTypes.IDENTITY_DOCUMENT_SUCCESS]: idDocSuccess,
    [CountriesTypes.IDENTITY_DOCUMENTS_COUNT_SUCCESS]: idDocsCountSuccess,
    [CountriesTypes.IDENTITY_DOCUMENTS_SUCCESS]: idDocsSuccess,
    [CountriesTypes.UPDATE_DOCUMENT_SUCCESS]: updateDocSuccess,
    [CountriesTypes.CREATE_DOCUMENT_SUCCESS]: createDocSuccess,
    [CountriesTypes.DISABLE_IDENTITY_DOCUMENT_SUCCESS]: disableIdDocSuccess,
    [CountriesTypes.UPDATE_COUNTRY_SUCCESS]: updateCountrySuccess,
    [CountriesTypes.ZONES_SUCCESS]: zonesSuccess,

    [CountriesTypes.COUNTRY_FAILURE]: countryFailure,
    [CountriesTypes.COUNTRIES_FAILURE]: countriesFailure,
    [CountriesTypes.IDENTITY_DOCUMENT_FAILURE]: idDocFailure,
    [CountriesTypes.IDENTITY_DOCUMENTS_COUNT_FAILURE]: idDocsCountFailure,
    [CountriesTypes.IDENTITY_DOCUMENTS_FAILURE]: idDocsFailure,
    [CountriesTypes.UPDATE_DOCUMENT_FAILURE]: updateDocFailure,
    [CountriesTypes.CREATE_DOCUMENT_FAILURE]: createDocFailure,
    [CountriesTypes.DISABLE_IDENTITY_DOCUMENT_FAILURE]: disableIdDocFailure,
    [CountriesTypes.UPDATE_COUNTRY_FAILURE]: updateCountryFailure,
    [CountriesTypes.ZONES_FAILURE]: zonesFailure,

    [CountriesTypes.SAVE_COUNTRY]: saveCountry,
})